import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Utilities */
import _ from 'lodash'

/* Components */
import NotificationStackItem from './item'

/* Actions */
import {
    pull
} from 'react-redux/actions/notification'

/* Selector */
import {
    getStack
} from 'react-redux/selectors/notification'
import { ERROR, WARNING, STATUS, PROCESS, PROGRESS } from './type'

/* Styles */
import './stack.css'

/* Notification Stack component */
class NotificationStack extends Component {

  renderNotifications() {
    const { t, stack } = this.props
    let count = 0
    const maxStacked = 3
    return (
      _.map(stack, (item) => {
        if (count++<=maxStacked && (item.type === ERROR || item.type === WARNING)) return (
          <NotificationStackItem key={ item.uid } uid={ item.uid }/>
        )
        return null
      })
    )
  }

  render() {
    const { t, stack } = this.props
    return (
      <div className="notification-stack component">
        <ul>
          { this.renderNotifications() }
        </ul>
      </div>
    )
  }
}

NotificationStack.propTypes = {}

function mapStateToProps(state) {
  return Object.assign(
    {},
    { stack: getStack(state) }
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      pull
    },
    dispatch
  )
}

const reduxComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationStack)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/notification/stack.jsx